import { render, staticRenderFns } from "./pickatime.vue?vue&type=template&id=3c83de40&"
import script from "./pickatime.vue?vue&type=script&lang=js&"
export * from "./pickatime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pickatime.vue"
export default component.exports